import React, { PropTypes, Component } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import { getTimeLeftLabel } from 'common/utils';

export default class DeadlineModal extends Component {
  constructor(props) {
    super(props);
    this.onExtend = this.onExtend.bind(this);
    this.changeDeadlineSelect = this.changeDeadlineSelect.bind(this);
    this.onDone = this.onDone.bind(this);
    this.state = { days: 1 };
  }

  onExtend() {
    const { extendDeadline, projectId } = this.props;
    extendDeadline(projectId, this.state.days);
  }

  changeDeadlineSelect(e) {
    const value = e.target.value;
    this.setState({ days: value });
  }

  onDone() {
    this.props.toggleSuccessModal()
    /* reload project with updated deadline */
    this.props.fetchProject()
  }

  render() {
    const { showModal, toggleExtendModal, showSuccessModal, toggleSuccessModal } = this.props;
    const days = Array.from(Array(7).keys());

    return (
      <div>
        <ModalDialog
          dialogClasses="extend-deadline-modal"
          onPrimary={this.onExtend}
          primaryLabel="Extend"
          secondaryLabel="Cancel"
          onSecondary={toggleExtendModal}
          modalOpen={showModal}
          closeAction={toggleExtendModal}
          modalHeader="Extend Your Project"
        >
          <p>You can extend your project for up to 7 days, but you can only extend once.</p>
          <select onChange={this.changeDeadlineSelect} value={this.state.days}>
            { days.map((day, key) => (
              <option key={key} value={(key * 1) + 1}>{(key * 1) + 1}</option>
            )) }
          </select>
        </ModalDialog>
        <ModalDialog
          dialogClasses="extended-success-modal"
          onPrimary={this.onDone}
          primaryLabel="Done"
          modalOpen={showSuccessModal}
          closeAction={this.onDone}
          modalHeader="Extend Your Project"
        >
          <i className="fa fa-check-circle" />
          <h2>Project Extended</h2>
          <p>
            Your project has been extended by {this.state.days} days.
            We'll share your message with your participants.
          </p>
        </ModalDialog>
      </div>);
  }
}

DeadlineModal.propTypes = {
  projectId: PropTypes.number.isRequired,
  showModal: PropTypes.bool,
  showSuccessModal: PropTypes.bool,
  extendDeadline: PropTypes.func.isRequired,
  toggleExtendModal: PropTypes.func.isRequired,
  toggleSuccessModal: PropTypes.func.isRequired,
  fetchProject: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/deadline_modal.jsx